/**
 * ヘッダー制御
 */
export default class EstimateOrder extends HTMLElement {

  constructor() {
    super();

    const input01 = this.querySelector("input[type=text]:first-of-type");
    const input02 = this.querySelector("input[type=text]:nth-of-type(2)");
    const errorMessage = this.querySelector(".unico-estimate-order-error");
    const submitButton = this.querySelector("[data-target-id=estimate-order-button]");

    submitButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (input01.value.length !== 12 || input02.value.length !== 3) {
        input01.setAttribute("aria-invalid", "true");
        input02.setAttribute("aria-invalid", "true");
        errorMessage.setAttribute("aria-hidden", "false");
        return;
      }

      const estimateNumber = `${input01.value}-${input02.value}`;
      window.location.href = `/cart?estimate=${estimateNumber}`;
    });
  }
}
